import { getVariant, get } from '@/api/train-schedule'
import { make } from 'vuex-pathify'

const state = {
  all: {},
  operators: [],
  activeOperator: null,
  active: null,
  pending: false,
  showSelectOperatorModal: false,
  display: {
    operator: null,
    sokande: null
  }
}

const mutations = make.mutations(state)

const actions = {
  async fetch({ commit }, params) {
    commit('SET_PENDING', true)
    commit('SET_ALL', {})
    commit('SET_ACTIVE', null)
    commit('trainChange/SET_INITED', false, { root: true })
    commit('trainChange/SET_ALL', {}, { root: true })
    commit('trainChange/SET_ACTIVE', null, { root: true })
    commit('timetable/SET_SELECTED_DATE_CELL', null, { root: true })
    const { data: variantData } = await getVariant(params)
    if (variantData.length > 1) {
      commit('SET_OPERATORS', variantData)
      commit('SET_SHOW_SELECT_OPERATOR_MODAL', true)
    } else {
      commit('SET_ACTIVE_OPERATOR', variantData[0])
      try {
        const { data } = await get({ ...params, ...variantData[0] })
        commit('SET_ALL', data)
        commit('SET_DISPLAY', {
          operator: variantData[0].operator,
          sokande: variantData[0].sokande
        })
      } catch (err) {
        console.log(err)
        commit('SET_ALL', [])
        commit('SET_DISPLAY', {
          operator: null,
          sokande: null
        })
      }
    }

    commit('SET_PENDING', false)
  },

  async fetchAll({ commit, state }, params) {
    commit('SET_PENDING', true)
    commit('SET_ALL', {})
    commit('SET_ACTIVE', null)
    commit('trainChange/SET_INITED', false, { root: true })
    commit('trainChange/SET_ALL', {}, { root: true })
    commit('trainChange/SET_ACTIVE', null, { root: true })
    commit('timetable/SET_SELECTED_DATE_CELL', null, { root: true })
    const { data } = await get({ ...params, ...state.activeOperator })
    commit('SET_ALL', data)
    commit('SET_PENDING', false)
  }
}

const getters = {
  allList: state => Object.values(state.all)
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
